"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutstandingTaskAwaiter = void 0;
const exception_1 = require("./exception");
class OutstandingTaskAwaiter {
    constructor() {
        this.locked = false;
        this.outstandingTasks = [];
        this.errors = [];
    }
    async Wait() {
        this.locked = true;
        await Promise.all(this.outstandingTasks);
        if (this.errors.length) {
            if (this.errors.length == 1) {
                throw this.errors[0];
            }
            throw new exception_1.AggregateException(this.errors);
        }
    }
    async Await(task) {
        if (this.locked) {
            throw new exception_1.OutstandingTaskAlreadyCompletedException();
        }
        this.outstandingTasks.push(task.catch((e) => {
            // console.error("Yes. errors in the await.")
            this.errors.push(e);
        }));
        return task;
    }
}
exports.OutstandingTaskAwaiter = OutstandingTaskAwaiter;
//# sourceMappingURL=outstanding-task-awaiter.js.map